import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Mobilde form dialog'larında Kaydet/Vazgeç her zaman görünür (dialog scroll container'ına yapışır).
export const MOBILE_STICKY_FOOTER =
  "sticky bottom-[-1.5rem] z-10 -mx-6 -mb-6 px-6 py-3 bg-white border-t border-slate-200 flex-row justify-end gap-2 "
  + "[&>button]:h-11 [&>button]:flex-1 sm:[&>button]:flex-none "
  + "md:static md:mx-0 md:mb-0 md:p-0 md:border-0 md:bg-transparent md:gap-0 md:[&>button]:h-9";

export const isMobileViewport = () =>
  typeof window !== "undefined" && window.matchMedia && window.matchMedia("(max-width: 767px)").matches;
